import keyMirror from 'keymirror';

export const nextExerciseDetailsActionTypes = keyMirror({
	GET_QUESTION_EXPLANATION: null,
	GET_QUESTION_EXPLANATION_SUCCESS: null,
	GET_QUESTION_EXPLANATION_ERROR: null,
	GET_TOPIC_EXPLANATION: null,
	GET_TOPIC_EXPLANATION_SUCCESS: null,
	GET_TOPIC_EXPLANATION_ERROR: null,

	SEND_QUESTION_ANSWER_REQUEST: null,
	SEND_QUESTION_ANSWER_SUCCESS: null,
	SEND_QUESTION_ANSWER_ERROR: null,

	CLEAR_EXPLANATION: null,
	CLEAR_STATE: null,

	SET_EXERCISE_SCORE: null,

	CREATE_EXERCISE: null,
	CREATE_EXERCISE_SUCCESS: null,
	CREATE_EXERCISE_ERROR: null,

	RESUME_EXERCISE_REQUEST: null,
	RESUME_EXERCISE_SUCCESS: null,
	RESUME_EXERCISE_ERROR: null,

	STOP_TEST: null,
	STOP_TEST_ERROR: null,

	STORE_TIME: null,
	STORE_ERROR: null,
	STORE_TIME_BETWEEN: null,
	SET_FINISH_EXERCISE: null,

	HANDLE_NEXT_EXERCISE_TYPES: null,

	CHECK_WORDS_BY_TYPO: null,
	CHECK_WORDS_BY_TYPO_SUCCESS: null,

	COUNT_AS_CORRECT: null,
	COUNT_AS_INCORRECT: null,

	GET_ADDITIONAL_EXPLANATION_REQUEST: null,
	GET_ADDITIONAL_EXPLANATION_SUCCESS: null,

	CHECK_ANSWER_REQUEST: null,
	CHECK_ANSWER_SUCCESS: null,
	CHECK_ANSWER_ERROR: null,

	PERSONALIZED_QUESTION_REQUEST: null,
	PERSONALIZED_QUESTION_SUCCESS: null,
	PERSONALIZED_QUESTION_ERROR: null,

	GET_AI_EXPLANATION_REQUEST: null,
	GET_AI_EXPLANATION_SUCCESS: null,
	GET_AI_EXPLANATION_ERROR: null,

	SET_REQUEST_ID: null,

	CHECK_IMAGE_BY_AI: null,
	CHECK_IMAGE_BY_AI_SUCCESS: null,
	CHECK_IMAGE_BY_AI_ERROR: null,
	CLEAR_CHECK_IMAGE_BY_AI_STATE: null,
});

export const TEST_TYPE = {
	REGULAR: 'regular',
	DIAGNOSTIC: 'diagnostic',
	QUIZ: 'quiz',
	EXAM: 'full',
	PRACTICE_SET: 'set',
};
export const DEFAULT_SPEECH_LOCALE = 'nl';

export const formatStringToBase64 = (string) => {
	const encodedURI = encodeURIComponent(string);
	return btoa(encodedURI);
};

export const formatQuestion = (array) =>
	array.reduce((acc, element) => {
		if (typeof element === 'string') {
			return acc + element;
		}
		if (Array.isArray(element)) {
			const [option1, option2] = element;
			return `${acc} (${option1}/${option2}) `;
		}
		return acc;
	}, '');

export const excludedExerciseTypes = [
	TEST_TYPE.QUIZ,
	TEST_TYPE.EXAM,
	TEST_TYPE.PRACTICE_SET,
	TEST_TYPE.REGULAR,
];
